export function menu() {

  //navi sp
  jQuery(function ($) {
    if (window.matchMedia('(max-width: 767px)').matches) {
      // 親メニュー処理
      $('.menu-item-has-children').click(function() {
        $(this).toggleClass('menu_open');
        // メニュー表示/非表示
        $(this).next('.sub-menu').slideToggle();
      });
      // 子メニュー処理
      $('.menu-item-has-children').click(function(e) {
          // メニュー表示/非表示
          $(this).children('.sub-menu').slideToggle();
          e.stopPropagation();
      });
    }
  });

  //navi SP
  jQuery(function ($) {
    $('#toggle').click(function(){
        if($(this).hasClass('active')){
            $(this).removeClass('active');
            $('.l-header').removeClass('active');
            $('.l-header_navArea').fadeOut();
        }else{
            $(this).addClass('active');
            $('.l-header').addClass('active');
            $('.l-header_navArea').fadeIn();
        }
    });
    $('.l-header_navArea a').click(function() {
        if($('.l-header').hasClass('active')){
            $('.l-header_navArea').fadeOut();
            $('.l-header').removeClass('active');
            $('#toggle').removeClass('active');
        }
    });
    $('.nav_close').click(function() {
        if($('.l-header').hasClass('active')){
            $('.l-header_navArea').fadeOut();
            $('.l-header').removeClass('active');
            $('#toggle').removeClass('active');
        }
    });
  });

}